import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Mail, Phone } from "lucide-react";

const FbIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
  </svg>
);

const IgIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
    <circle cx="12" cy="12" r="4" />
    <circle cx="17.5" cy="6.5" r="0.5" fill="currentColor" stroke="none" />
  </svg>
);

const WaIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
    <path d="M12 2C6.477 2 2 6.477 2 12c0 1.89.525 3.66 1.438 5.168L2 22l4.978-1.413A9.953 9.953 0 0 0 12 22c5.523 0 10-4.477 10-10S17.523 2 12 2zm0 18a7.95 7.95 0 0 1-4.076-1.12l-.292-.173-3.032.861.872-3.018-.19-.31A7.96 7.96 0 0 1 4 12c0-4.418 3.582-8 8-8s8 3.582 8 8-3.582 8-8 8z" />
  </svg>
);
import { Logo } from "./Logo";

export const Footer = () => (
  <footer className="bg-[#E6E9F9]" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 md:px-8 py-10">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6 pb-6">
        <Logo />
        <div className="flex items-center gap-3">
          {[
            { Icon: FbIcon, label: "Facebook", href: "https://www.facebook.com/springkids.edu" },
            { Icon: IgIcon, label: "Instagram", href: "https://www.instagram.com/springkids.preschool" },
            { Icon: WaIcon, label: "WhatsApp", href: "https://wa.me/919845025709" },
          ].map(({ Icon, label, href }) => (
            <a
              key={label}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-full bg-white flex items-center justify-center text-kid-navy hover:bg-kid-lilac hover:text-white transition-all duration-300"
              data-testid={`footer-social-${label.toLowerCase()}`}
              aria-label={label}
            >
              <Icon />
            </a>
          ))}
        </div>
      </div>

      <div className="border-t border-white pt-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-kid-navy">
        <div className="space-y-1 text-sm md:text-base">
          <div className="flex items-center gap-2"><MapPin size={16} /> #269, 1st Cross, Beside Brigade Omega Apartment, Banashankari 6th Stage 1st Block, Bangalore - 560 061</div>
          <div className="flex items-center gap-2"><Phone size={16} /> 9845025709</div>
          <div className="flex items-center gap-2"><Mail size={16} /> springKids.edu@gmail.com</div>
        </div>
        <div className="flex flex-wrap gap-4 text-sm md:text-base">
          <Link to="/" className="hover:text-kid-amber" data-testid="footer-link-home">Home</Link>
          <span className="opacity-30">|</span>
          <Link to="/about" className="hover:text-kid-amber" data-testid="footer-link-about">About</Link>
          <span className="opacity-30">|</span>
          <Link to="/programs" className="hover:text-kid-amber" data-testid="footer-link-programs">Programs</Link>
          <span className="opacity-30">|</span>
          <Link to="/activities" className="hover:text-kid-amber" data-testid="footer-link-activities">Activities</Link>
          <span className="opacity-30">|</span>
          <Link to="/gallery" className="hover:text-kid-amber" data-testid="footer-link-gallery">Gallery</Link>
          <span className="opacity-30">|</span>
          <Link to="/contact" className="hover:text-kid-amber" data-testid="footer-link-contact">Contact</Link>
        </div>
      </div>
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1 mt-6">
        <p className="text-xs text-kid-navy/60">Spring Kids © {new Date().getFullYear()}. All rights reserved.</p>
        <p className="text-xs text-kid-navy/40">Built by TermiLabs</p>
      </div>
    </div>
  </footer>
);
